import { createAsyncThunk } from '@reduxjs/toolkit';

import { ReturnValidateToken, validateAndDecodeToken } from '@sharedHelpers/validateAndDecodeToken';

export const getAuthMe = createAsyncThunk<ReturnValidateToken>('auth/getAuthMe', async () => {
  return await validateAndDecodeToken().catch(() => null);
});
